import Footer from "../customer/components/footer";
import Header from "../customer/components/header";

const CustomerLayout = ({ children }) => {

  return (<>
    <Header />
    {children}
    <Footer />
  </>);
}

export default CustomerLayout;